import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PageType } from 'src/app/analytics/newrelic/enums/PageType';
import { TabService } from '../tabs/tab.service';
import { Location } from "@angular/common";
import { SubscriptionHandlerService } from '../subscription-handler.service';

@Injectable({
  providedIn: 'root',
})
export class ScreenService {
  searchItemPosition = 'NA';
  private previouscreen: string;
  private currentscreen: string;
  private searchLink: string;
  private history: string[] = [];
  private navigation$ = new BehaviorSubject({
    previousScreen: undefined,
    currentscreen: undefined,
    tabId: undefined,
    tabName: undefined,
    type: undefined,
    tabs: undefined,
  });
  private serviceName = 'ScreenService';

  get currentScreen(): string {
    return this.currentscreen;
  }

  set currentScreen(value: string) {
    this.currentscreen = value;
  }

  set previousScreen(value: string) {
    this.previouscreen = value;
  }

  get previousScreen(): string {
    return this.previouscreen;
  }

  get searchlink(): string {
    return this.searchLink;
  }

  set searchlink(value: string) {
    this.searchLink = value;
  }

  constructor(
    private router: Router,
    private tabService: TabService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private readonly subscriptionHandlerService: SubscriptionHandlerService
  ) {
    const navigation: Subscription = this.navigation$.asObservable().subscribe((result) => {
      if (result.type === 'tab') {
        this.tabService.currentTabId = result.tabId;
        this.tabService.currentTabName = result.tabName;
      } else {
        this.setCurrentScreen(result.currentscreen);
      }
    });
    this.subscriptionHandlerService.addSubscription(this.serviceName, 'navigation', navigation);

    const routerEvents: Subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.history?.push(event.urlAfterRedirects);
        let pageId =
          this.activatedRoute?.snapshot?.firstChild?.data?.pageID || this.activatedRoute?.firstChild?.snapshot?.firstChild?.data?.pageID;
        if (this.router.url.includes('epg')) {
          pageId = PageType.Epg;
        }
        this.setCurrentScreen(pageId);
      }
    });
    this.subscriptionHandlerService.addSubscription(this.serviceName, 'routerEvents', routerEvents);
  }

  setCurrentScreen(currentScreen: string): void {
    this.previouscreen = this.currentscreen;

    if (currentScreen === PageType.Browse) {
      this.currentscreen = this.tabService.currentTabName;
    } else {
      this.currentscreen = currentScreen;
    }
  }

  navigateBack(fallbackUrl: string = '/'): void {
    this.history.pop();
    if (this.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigateByUrl(fallbackUrl);
    }
  }
}
